import styles from "./MypageInput.module.scss";
import { validateRequired } from "../../utils/validate";

const MypageSelect = ({
  register,
  validation = {},
  name,
  errors,
  label,
  isStatic,
  options = [],
  watch,
  required = false,
  isSetdefalut = false,
  defalut = { value: "", text: "---選択していません---" },
}) => {
  const selectedText = options.find((opt) => {
    return opt.value === watch(name);
  });

  /**** バリデーションルール設定 ****/
  // 項目ごとのルール
  let slct_validation = validation;
  if (required) {
    // 必須項目なら必須バリデーションルール設定
    slct_validation = { ...slct_validation, ...validateRequired() };
  }

  return (
    <div className={styles.mypageform__block}>
      <div className={styles.mypageform__ttl}>
        {label}
        <span className={styles.mypageform__ttl__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </div>
      <div
        className={`${styles.mypageform__selectfield} ${
          isStatic ? "d-none" : ""
        }`}
      >
        <select
          name={name}
          className={`form-select ${styles.mypageform__select} ${
            errors[name] ? "is-invalid" : ""
          }`}
          {...register(name, slct_validation)}
        >
          {isSetdefalut && (
            <option value={defalut.value} key={defalut.value}>
              {defalut.text}
            </option>
          )}
          {options.map((option) => (
            <option value={option.value} key={option.value}>
              {option.text}
            </option>
          ))}
        </select>
        <>
          {errors[name] ? (
            <p className={`invalid-feedback ${styles.mypageform__msg}`}>
              {errors[name].message}
            </p>
          ) : (
            <></>
          )}
        </>
      </div>
      {isStatic && (
        <div className={`${styles.mypageform__label} ps-4`}>
          {selectedText?.text ? selectedText?.text : <p>&emsp;</p>}
        </div>
      )}
    </div>
  );
};
export default MypageSelect;
